import React from 'react'

const GeneralRules = () => {
  return (
    <div className="container m-auto p-4 md:py-6">
      <div className="text-grey-1000 leading-normal">
        <div className="text-justify">
          <div>
            <h1 className="text-2xl font-semibold mb-1 leading-loose">
              General Rules regarding Booking and Reservations
            </h1>
            <p className="mb-3">
              yatratickets.com is the trusted online ticketing platform of GANDAKI TOURS AND TRAVELS Pvt. Ltd., offering both domestic and international tickets at affordable, competitive prices worldwide. With 35 years of experience in providing exceptional travel services, GANDAKI TOURS AND TRAVELS Pvt. Ltd now makes it easier than ever to book your flights quickly and effortlessly through this portal. Our mission is to simplify travel and make it accessible to everyone. We offer a full range of travel services, including flight tickets, accommodation, tours, and all other travel-related activities.
            </p>

          </div>
          <div>
            <h2 className="text-2xl font-semibold mb-1 leading-loose">
              Gandaki Tours & Travels Pvt. Ltd. (Travel Agency) and User (Customer) Agreement
            </h2>
            <p className="mb-3">
              Gandaki Tours & Travels Pvt. Ltd. has established the following Rules and Restrictions to ensure compliance with Nepal's laws and tourism norms while providing travel services.

            </p>
          </div>
          <div>
            <h2 className="text-2xl font-semibold mb-1 leading-loose">
              General Rules:
            </h2>
            <p className="mb-3">
              <ol>
                <li>
                  <p>
                    <b>
                      1. Payment Requirements:
                    </b>

                  </p>
                  <p>
                    Full payment is mandatory for all services provided by Gandaki Tours & Travels. If there is any increase in taxes or airfare after booking, customers will be promptly informed, and the additional charges will be applied. Bookings may be canceled by either the airline or Gandaki Tours & Travels if payment is not fully realized by the due date.

                  </p>
                </li>
                <li>
                  <p>
                    <b>
                      2. Payment Issues:
                    </b>

                  </p>
                  <p>
                    In the event that payment is declined or not approved (e.g., due to issues with credit cards or cheques), the customer will be notified immediately. The customer must then provide an alternative payment method or rectify the issue with their bank or financial institution to avoid cancellation of the booking.
                  </p>
                </li>
                <li>
                  <p>
                    <b>
                      3. Booking Errors:
                    </b>

                  </p>
                  <p>
                    Customers are required to review their booking details carefully. Any errors in bookings should be reported to Gandaki Tours & Travels within 24 hours of receiving the confirmation email or product receipt. Failure to report within this timeframe may result in the inability to correct the error without additional costs.
                  </p>
                </li>
                <li>
                  <p>
                    <b>
                      4.Ticket Validity and Restrictions:
                    </b>

                  </p>
                  <p>
                    All tickets issued have a validity period within which travel must be completed. Any date changes must occur within this validity period. Discounted tickets come with specific restrictions, including limitations on class upgrades. The availability of mileage credits or frequent flyer miles is at the discretion of the respective airline.
                  </p>
                </li>
                <li>
                  <p>
                    <b>
                      5. Changes and Cancellations:
                    </b>

                  </p>
                  <p>
                    Date changes and cancellations should be initiated through Gandaki Tours & Travels’ customer care. However, there may be cases where the customer is required to contact the airline directly. A service fee of Rs. 150 will be charged for any date changes, and additional airline-imposed penalties may apply. In the event of cancellation, a processing fee will be charged (Rs. 1,500 for full refunds). No refunds will be provided for partially used tickets or for NO SHOWS.</p>
                </li>
                <li>
                  <p>
                    <b>
                      6. Delivery and Courier Services:
                    </b>

                  </p>
                  <p>
                    Delivery of travel products within Nepal is free of charge. For international deliveries, a courier fee will be applied. Gandaki Tours & Travels is not responsible for any loss or damage caused by courier services during the delivery process.
                  </p>
                </li>
                <li>
                  <p>
                    <b>
                      7. Refund Policy:
                    </b>

                  </p>
                  <p>
                    Refunds for e-tickets will be processed within 7 business days, while refunds for paper tickets may take up to 21 business days. To initiate a refund for paper tickets, customers must return the tickets to Gandaki Tours & Travels. Note that insurance costs are non-refundable, regardless of the reason for cancellation.
                  </p>
                </li>
                <li>
                  <p>
                    <b>
                      8. Flight Reconfirmation:
                    </b>

                  </p>
                  <p>
                    It is the customer’s responsibility to reconfirm flight timings with the airline 24 hours prior to departure. While Gandaki Tours & Travels will notify customers of any schedule changes made by the airline, they are not liable for such changes after the ticket has been issued.
                  </p>
                </li>
                <li>
                  <p>
                    <b>
                      9. Infants and Unaccompanied Minors:
                    </b>

                  </p>
                  <p>
                    Infants (under 24 months) must travel with an accompanying adult. If an infant turns 24 months or older during the return journey, a child fare will apply. For families traveling with more than one infant, the first infant is charged an infant fare, while subsequent infants are charged the applicable child fare. Some airlines do not allow unaccompanied minors or require that young adults (aged 12-16) traveling alone are accompanied. Customers are advised to verify these details with customer care before booking.
                  </p>
                </li>
                <li>
                  <p>
                    <b>
                      10. Travel Documents:                      :
                    </b>

                  </p>
                  <p>
                    Customers are responsible for ensuring they have all necessary and valid travel documents, such as passports, visas, health certificates, and travel insurance. Gandaki Tours & Travels is not responsible for issues related to visa or travel document validity and cannot be held liable for any complications arising from insufficient or invalid documentation.
                  </p>
                </li>

              </ol>
            </p>
            <p>
              These rules and restrictions are designed to ensure a smooth travel experience for customers and to safeguard the interests of both Gandaki Tours & Travels and its customers. Compliance with these guidelines is essential for the successful processing of all travel-related services.

            </p>
          </div>

        </div>
      </div>
    </div>
  )
}

export default GeneralRules
